<template>
	<div>
		<!-- Non-permission Error Alert -->
		<v-row v-if="error && !showPermissionHelp">
			<v-col cols="12">
				<v-alert type="error" variant="tonal" density="compact" class="mb-0">
					{{ error }}
				</v-alert>
			</v-col>
		</v-row>

		<!-- Permission Instructions -->
		<v-row v-if="showPermissionHelp || error">
			<v-col cols="12">
				<v-card flat>
					<v-card-title v-if="showPermissionHelp" class="text-h6 px-2"> Enable Location Permissions </v-card-title>

					<v-card-text v-if="showPermissionHelp" class="px-2" style="color: rgba(0,0,0,0.60) !important">
						<p><strong>To use this feature, please enable location permissions:</strong></p>
						<ul>
							<li><strong>Chrome/Edge:</strong> Click the location icon in the address bar</li>
							<li><strong>Firefox:</strong> Click "Share Location" when prompted</li>
							<li><strong>Safari:</strong> Go to Settings → Privacy & Security → Location Services</li>
							<li><strong>Mobile:</strong> Check your browser's location settings</li>
						</ul>
					</v-card-text>

					<v-card-actions class="px-2">
						<v-row class="mt-2">
							<v-col cols="6">
								<v-btn rounded="xl" variant="outlined" block elevation="0" color="black" class="white-bg" @click="cancel()">
									Cancel
								</v-btn>
							</v-col>
							<v-col cols="6">
								<v-btn color="primary" variant="flat" rounded="xl" block elevation="0" @click="tryAgain"> Try again </v-btn>
							</v-col>
						</v-row>
					</v-card-actions>
				</v-card>
			</v-col>
		</v-row>
	</div>
</template>

<script setup lang="ts">
	defineProps<{
		error: string;
		showPermissionHelp: boolean;
	}>();

	const emit = defineEmits<{
		(e: "cancel"): void;
		(e: "try-again"): void;
	}>();

	function cancel() {
		emit("cancel");
	}

	function tryAgain() {
		emit("try-again");
	}
</script>

<style scoped></style>
